// 24 VIA Character Strengths grouped by 6 virtues (PT)
export const VIA_STRENGTHS = {
  "Sabedoria (Wisdom)": [
    "Curiosidade",
    "Amor ao Aprendizado",
    "Critério",
    "Criatividade",
    "Perspectiva",
  ],
  "Coragem (Courage)": [
    "Integridade",
    "Vitalidade",
    "Bravura",
    "Perseverança",
  ],
  "Humanidade (Humanity)": [
    "Inteligência Social",
    "Generosidade",
    "Amor",
  ],
  "Justiça (Justice)": [
    "Trabalho em Equipa",
    "Justiça",
    "Liderança",
  ],
  "Temperança (Temperance)": [
    "Perdão",
    "Humildade",
    "Autocontrolo",
    "Prudência",
  ],
  "Transcendência (Transcendence)": [
    "Espiritualidade",
    "Esperança",
    "Apreciação da beleza e excelência",
    "Humor",
    "Gratidão",
  ],
};

export const VIA_ALL = Object.values(VIA_STRENGTHS).flat();

// MBTI → suggested VIA strengths (natural alignment heuristic)
export const MBTI_VIA_SUGGESTIONS = {
  INTJ: ["Critério", "Criatividade", "Perspectiva", "Perseverança"],
  INTP: ["Amor ao Aprendizado", "Curiosidade", "Critério", "Criatividade"],
  ENTJ: ["Liderança", "Bravura", "Integridade", "Perseverança"],
  ENTP: ["Criatividade", "Curiosidade", "Humor", "Bravura"],
  INFJ: ["Espiritualidade", "Esperança", "Generosidade", "Perspectiva"],
  INFP: ["Apreciação da beleza e excelência", "Criatividade", "Generosidade", "Amor"],
  ENFJ: ["Liderança", "Generosidade", "Esperança", "Inteligência Social"],
  ENFP: ["Criatividade", "Curiosidade", "Gratidão", "Vitalidade"],
  ISTJ: ["Integridade", "Prudência", "Perseverança", "Autocontrolo"],
  ISFJ: ["Generosidade", "Humildade", "Justiça", "Gratidão"],
  ESTJ: ["Liderança", "Justiça", "Prudência", "Trabalho em Equipa"],
  ESFJ: ["Inteligência Social", "Trabalho em Equipa", "Amor", "Generosidade"],
  ISTP: ["Curiosidade", "Autocontrolo", "Bravura", "Critério"],
  ISFP: ["Apreciação da beleza e excelência", "Humildade", "Criatividade", "Amor"],
  ESTP: ["Bravura", "Vitalidade", "Humor", "Inteligência Social"],
  ESFP: ["Humor", "Vitalidade", "Gratidão", "Amor"],
};

export function suggestedViaFor(mbti) {
  if (!mbti) return [];
  return MBTI_VIA_SUGGESTIONS[String(mbti).toUpperCase()] || [];
}

export function isValidVia(name) {
  return VIA_ALL.includes(name);
}
